module.exports = __webpack_public_path__ + "static/media/Librairie_jean_calvin.5353ca23.svg";